export default __webpack_public_path__ + "static/media/menuBoxed.72c103db.svg";